<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="inputable-control-container">
    <div class="inputable-control">
        @if (selectedOption?.editType && !readonly) {
            <input
                    (ngModelChange)="setValue($event)"
                    [max]="getMax(selectedOption)"
                    [min]="getMin(selectedOption)"
                    [ngModel]="config.value"
                    class="form-control form-control-sm col font-size-12"
                    required
                    type="number"
            />
        } @else {
            <span class="form-control-label mb-0 font-size-12">{{ getSelectedOption() }}</span>
        }

        @if (!readonly) {
            <div (click)="toggleOpen()" (keydown)="toggleOpen()" class="dropdown-toggle"></div>
        }

    </div>

    <ul (mouseleave)="isOpen = false" [ngClass]="{ open: isOpen }" class="options-dropdown">
        @for (option of config.options; track $index) {
            <li (click)="selectOption(option)" (keydown)="selectOption(option)" [ngClass]="{ active: isOptionActive(option) }">
                {{ option.text }}
            </li>
        }
    </ul>
</div>
